import { useWritableMarketPreflight } from '@/features/market/useWritableMarketPreflight';
import * as React from 'react';

export function useWritableMarketGuard() {
  const ensureWritableMarket = useWritableMarketPreflight();

  return React.useCallback(() => {
    return ensureWritableMarket();
  }, [ensureWritableMarket]);
}
